import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Avatar,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Button,
  Typography,
} from "@mui/material";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../../firebase.config"; // adapte le chemin si besoin
import CustomButton from "../../../Components/CustomButton";

export default function EditAvatarModal({
  open,
  onClose,
  currentPhotoUrl,
  userId,
  onPhotoUpdated,
}) {
  const [preview, setPreview] = useState(currentPhotoUrl || "");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPreview(currentPhotoUrl || "");
    setFile(null);
  }, [currentPhotoUrl, open]);

  const handleFileChange = (e) => {
    const selected = e.target.files?.[0];
    if (!selected) return;

    // Optionnel : filtrer les types de fichier
    if (!selected.type.startsWith("image/")) {
      alert("Merci de sélectionner une image.");
      return;
    }

    setFile(selected);
    const url = URL.createObjectURL(selected);
    setPreview(url);
  };

  const handleSave = async () => {
    if (!file || !userId) {
      onClose();
      return;
    }

    setLoading(true);
    try {
      const filePath = `profilePictures/${userId}-${Date.now()}`;
      const storageRef = ref(storage, filePath);
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);

      if (onPhotoUpdated) {
        await onPhotoUpdated(downloadURL);
      }
      onClose();
    } catch (error) {
      console.error("Erreur upload photo profil :", error);
      alert("Une erreur est survenue lors du téléchargement de la photo.");
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>Modifier la photo de profil</DialogTitle>
      <DialogContent>
        <Stack spacing={2} alignItems="center" mt={1}>
          <Avatar
            src={preview || undefined}
            sx={{ width: 90, height: 90, bgcolor: "#5E17EB", fontSize: 32 }}
          >
            {!preview && "?"}
          </Avatar>

          <Button variant="outlined" component="label">
            Choisir une image
            <input
              type="file"
              hidden
              accept="image/*"
              onChange={handleFileChange}
            />
          </Button>

          <Typography variant="body2" color="text.secondary" align="center">
            Formats recommandés : JPG, PNG.  
            Taille max conseillée : 2–3 Mo.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2, pb: 2 }}>
        <Button
          onClick={onClose}
          disabled={loading}
          color="inherit"
        >
          Annuler
        </Button>
        <CustomButton
          loading={loading}
          buttonText="Enregistrer"
          onClick={handleSave}
        />
      </DialogActions>
    </Dialog>
  );
}

EditAvatarModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  currentPhotoUrl: PropTypes.string,
  userId: PropTypes.string,
  onPhotoUpdated: PropTypes.func,
};
